/**
 * ============================================================================
 * AJAX CART - KAMPAGNEN & GESCHENKE VERWALTUNG
 * ============================================================================
 *
 * Dieses Skript verwaltet Kampagnen und automatische Geschenke im Warenkorb.
 * Es nutzt Liquid Ajax Cart Mutations, um den Warenkorb dynamisch zu aktualisieren.
 *
 * WICHTIG:
 * Das Script fügt nur Produkte hinzu oder löscht - Shopify zieht selber Rabatte ab!
 * Shopify Discount-Regeln bestimmen ob ein Rabatt abgezogen wird
 */


// ============================================================================
// ABO vs. EINMALKAUF — EXKLUSIVITÄTSLOGIK (Hard Lock)
// ============================================================================
//
// Wird FRÜH registriert, damit window.dsCartExclusivity auch dann verfügbar
// ist, wenn die Kampagnen-Initialisierung unten einen Fehler wirft (z. B. weil
// das #ds-cart-campaigns-Element auf einer Seite fehlt).
(function initDsCartExclusivity() {
  const LOG = '[DS Cart Conflict]';

  /** @returns {"abo"|"einmal"|null} */
  function getItemBundleMode(item) {
    if (!item || !item.properties || !item.properties._set_id) return null;
    const hasAllocation = item.selling_plan_allocation != null;
    const paket = String(item.properties._paket || '');
    if (hasAllocation || /abo/i.test(paket)) return 'abo';
    return 'einmal';
  }

  /** @returns {"abo"|"einmal"|null} */
  function detectCartMode(cart) {
    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return null;
    for (const item of cart.items) {
      const mode = getItemBundleMode(item);
      if (mode) return mode;
    }
    return null;
  }

  /** @returns {Promise<boolean>} true wenn User „ersetzen" klickt */
  function promptCartConflict({ existingMode, incomingMode, sameMode = false, allowMerge = false, existingCount = 0, incomingCount = 0 }) {
    return new Promise(resolve => {
      const modal = document.getElementById('DSCartConflictModal');
      if (!modal) {
        console.warn(LOG, 'Modal #DSCartConflictModal not in DOM — aborting add defensively.');
        resolve(false);
        return;
      }

      const labels = (() => {
        try { return JSON.parse(modal.dataset.dsLabels || '{}'); } catch { return {}; }
      })();
      const existingLabels = labels.existing || {};
      const incomingLabels = labels.incoming || {};
      const reasonLabels   = labels.reason   || {};

      const existingEl = modal.querySelector('[data-ds-conflict-existing]');
      const incomingEl = modal.querySelector('[data-ds-conflict-incoming]');
      if (existingEl) existingEl.textContent = existingLabels[existingMode] || 'eine Bestellung';
      if (incomingEl) incomingEl.textContent = incomingLabels[incomingMode] || 'das neue Bundle';

      const reasonEl = modal.querySelector('[data-ds-conflict-reason]');
      if (reasonEl) {
        reasonEl.textContent = sameMode
          ? (reasonLabels.same    || 'Es kann immer nur ein Set im Warenkorb liegen.')
          : (reasonLabels.different || 'Einmalkauf und Abo können nicht gemeinsam bestellt werden.');
      }

      // Neue Box-Variante des Popups: zeigt, was im Warenkorb liegt, und bietet
      // "zur bestehenden Box hinzufügen" an (nur wenn der Aufrufer das unterstützt)
      const isBoxLayout = modal.hasAttribute('data-ds-box-layout');
      const mergeBtn = modal.querySelector('[data-ds-conflict-merge]');
      const showMerge = isBoxLayout && sameMode && allowMerge && !!mergeBtn;
      modal.classList.toggle('is-same', !!sameMode);
      modal.classList.toggle('can-merge', showMerge);
      if (mergeBtn) mergeBtn.hidden = !showMerge;
      const setCount = (sel, n) => modal.querySelectorAll(sel).forEach(el => { el.textContent = n; });
      setCount('[data-ds-conflict-existing-count]', existingCount || '');
      setCount('[data-ds-conflict-incoming-count]', incomingCount || '');
      setCount('[data-ds-conflict-total-count]', (existingCount || 0) + (incomingCount || 0));
      modal.querySelectorAll('[data-ds-conflict-has-counts]').forEach(el => { el.hidden = !(existingCount && incomingCount); });

      // Buttons nur im sichtbaren Bereich (Box-Variante hat je einen Bereich für "gleich" und "Abo/Einmal")
      const scope = isBoxLayout
        ? (modal.querySelector(sameMode ? '.ds-cart-conflict-modal__same' : '.ds-cart-conflict-modal__diff') || modal)
        : modal;
      const confirmBtn = scope.querySelector('[data-ds-conflict-confirm]');
      const cancelEls = [
        ...scope.querySelectorAll('[data-ds-conflict-cancel]'),
        ...modal.querySelectorAll('[data-ds-conflict-close]')
      ];

      const cleanup = (result) => {
        modal.setAttribute('hidden', '');
        document.body.style.overflow = '';
        if (confirmBtn) confirmBtn.removeEventListener('click', onConfirm);
        if (mergeBtn) mergeBtn.removeEventListener('click', onMerge);
        cancelEls.forEach(el => el.removeEventListener('click', onCancel));
        document.removeEventListener('keydown', onKey);
        resolve(result);
      };
      const onConfirm = () => cleanup(true);
      const onMerge = () => cleanup('merge');
      const onCancel = () => cleanup(false);
      const onKey = (e) => { if (e.key === 'Escape') cleanup(false); };

      if (confirmBtn) confirmBtn.addEventListener('click', onConfirm);
      if (mergeBtn && showMerge) mergeBtn.addEventListener('click', onMerge);
      cancelEls.forEach(el => el.addEventListener('click', onCancel));
      document.addEventListener('keydown', onKey);

      // Immer vor dem (ggf. geöffneten) Warenkorb anzeigen: ans Ende von <body>, höchste Ebene
      if (isBoxLayout && modal.parentElement !== document.body) document.body.appendChild(modal);
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      const focusBtn = showMerge ? mergeBtn : scope.querySelector('[data-ds-conflict-cancel]');
      if (focusBtn) focusBtn.focus();
      console.log(LOG, 'Modal shown — existing:', existingMode, 'incoming:', incomingMode);
    });
  }

  /**
   * Cart vollständig leeren. Nutzt bevorzugt `liquidAjaxCart.update`, damit
   * die Library ihren internen State konsistent hält — direkter Manipulieren
   * von `liquidAjaxCart.cart` bricht nachfolgende `add()`-Aufrufe.
   * Auf den `liquid-ajax-cart:request-end`-Event wird kurz gewartet, mit
   * Safety-Timeout als Fallback, falls der Event nicht feuert.
   */
  function clearCart(cart) {
    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
      return Promise.resolve(true);
    }
    const updates = cart.items.reduce((acc, item) => { acc[item.key] = 0; return acc; }, {});
    const lac = window.liquidAjaxCart;

    if (lac && typeof lac.update === 'function') {
      return new Promise((resolve) => {
        let settled = false;
        const finish = (via) => {
          if (settled) return;
          settled = true;
          document.removeEventListener('liquid-ajax-cart:request-end', onEnd);
          console.log(LOG, 'Cart cleared via liquidAjaxCart.update (' + via + ').');
          resolve(true);
        };
        const onEnd = () => finish('event');
        document.addEventListener('liquid-ajax-cart:request-end', onEnd);
        try {
          lac.update({ updates });
        } catch (e) {
          console.error(LOG, 'liquidAjaxCart.update threw:', e);
          finish('error');
        }
        // Safety-Timeout: 1.5s reicht für das Clear — blockiert den Flow
        // nicht, falls der Event aus irgendeinem Grund nicht feuert.
        setTimeout(() => finish('timeout'), 1500);
      });
    }

    // Fallback: direkter Fetch (wenn liquidAjaxCart nicht verfügbar)
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates })
    }).then(res => res.ok).catch(e => {
      console.error(LOG, 'Fallback clear failed:', e);
      return false;
    });
  }

  /**
   * @param {"abo"|"einmal"} incomingMode
   * @param {{ isAddingToExisting?: boolean }} options
   *   isAddingToExisting: true wenn das Produkt in ein bestehendes Bundle
   *   eingefügt wird (Platz vorhanden). In diesem Fall nur Abo↔Einmal prüfen,
   *   kein Modal für gleichen Modus.
   * @returns {Promise<boolean>} true = Add fortsetzen, false = abbrechen
   */
  // Set-ID der Box im Warenkorb, wenn der Kunde "zur bestehenden Box hinzufügen" gewählt hat
  let pendingMergeSetId = null;
  function takeMergeSetId() {
    const id = pendingMergeSetId;
    pendingMergeSetId = null;
    return id;
  }

  async function resolveCartConflict(incomingMode, { isAddingToExisting = false, allowMerge = false, incomingCount = 0 } = {}) {
    if (incomingMode !== 'abo' && incomingMode !== 'einmal') {
      console.warn(LOG, 'Unknown incomingMode:', incomingMode);
      return true;
    }

    // Cart-State: bevorzugt den In-Memory-Cache von liquidAjaxCart.
    // Der wird bei jeder Mutation automatisch frisch gehalten und spart
    // einen Netzwerk-Roundtrip. Fallback auf /cart.js nur, wenn der Cache
    // fehlt (z. B. ganz frühe Interaktion vor erstem Sync).
    let cart = window.liquidAjaxCart && window.liquidAjaxCart.cart;
    if (!cart || !Array.isArray(cart.items)) {
      try {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const res = await fetch(`${root}cart.js`, { headers: { 'Accept': 'application/json' } });
        if (res.ok) cart = await res.json();
      } catch (e) {
        console.warn(LOG, 'cart.js fetch failed', e);
      }
    }

    const existingMode = detectCartMode(cart);
    console.log(LOG, 'resolveConflict — incoming:', incomingMode, 'existing:', existingMode, 'isAddingToExisting:', isAddingToExisting);

    // Cart leer oder kein Bundle drin → Add einfach durchlassen
    const hasBundle = Array.isArray(cart && cart.items) &&
      cart.items.some(item => item.properties && item.properties._set_id != null && item.properties._set_id !== '');
    if (!existingMode || !hasBundle) return true;

    const sameMode = existingMode === incomingMode;

    // Produkt wird einem bestehenden Bundle desselben Typs hinzugefügt → kein Konflikt
    if (isAddingToExisting && sameMode) return true;

    // Neues Bundle bei bereits befülltem Cart → Modal zeigen
    const boxItem = cart.items.find(item => item.properties && item.properties._set_id != null && item.properties._set_id !== '');
    const boxSetId = boxItem ? String(boxItem.properties._set_id) : null;
    const existingCount = boxSetId
      ? cart.items.filter(item => item.properties && String(item.properties._set_id) === boxSetId).reduce((n, item) => n + (item.quantity || 0), 0)
      : 0;
    const confirmed = await promptCartConflict({ existingMode, incomingMode, sameMode, allowMerge, existingCount, incomingCount });
    if (!confirmed) {
      console.log(LOG, 'User cancelled.');
      return false;
    }
    if (confirmed === 'merge') {
      // Nichts löschen – der Aufrufer legt die neuen Backwaren in die bestehende Box (gleiche Set-ID)
      pendingMergeSetId = boxSetId;
      console.log(LOG, 'User merges into existing box', boxSetId);
      return true;
    }

    const cleared = await clearCart(cart);
    if (!cleared) return false;

    try {
      document.dispatchEvent(new CustomEvent('ds-cart:conflict-resolved', {
        detail: { existingMode, incomingMode }
      }));
    } catch (_) {}
    return true;
  }

  window.dsCartExclusivity = {
    detectMode: detectCartMode,
    getItemMode: getItemBundleMode,
    resolveConflict: resolveCartConflict,
    takeMergeSetId: takeMergeSetId
  };
  console.log(LOG, 'dsCartExclusivity initialisiert.');
})();


// ============================================================================
// ABO-INTERVALL-SELECT IM CART-DRAWER
// ============================================================================
//
// Rüstet den im Liquid gerenderten `.ds-cart-bundle__delivery`-Block für
// Abo-Bundles mit einem <select> aus. Der User kann das Lieferintervall
// (z. B. „alle 7/14/21/28 Tage") direkt im Drawer wechseln — für ALLE Items
// des Bundles gleichzeitig. Nur sichtbar bei Abo-Bundles mit ≥ 2 Plans.
(function initDsBundleInterval() {
  const LOG = '[DS Bundle Interval]';
  const productCache = {};

  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(r => r.ok ? r.json() : null)
      .then(p => { productCache[handle] = p; return p; })
      .catch(() => null);
  }

  // Plans der Group, die den aktuellen Plan enthält. Falls wir den Plan nicht
  // finden (z. B. weil er dekomissioniert wurde), fallen wir auf alle Plans
  // des Produkts zurück — sonst hätte der User gar keine Wechsel-Option.
  function getRelevantPlans(product, currentPlanId) {
    if (!product || !product.selling_plan_groups) return [];
    const id = String(currentPlanId);
    for (const g of product.selling_plan_groups) {
      if ((g.selling_plans || []).some(p => String(p.id) === id)) {
        return g.selling_plans;
      }
    }
    return product.selling_plan_groups.flatMap(g => g.selling_plans || []);
  }

  async function enrichOne(container) {
    if (container.dataset.dsEnriched === '1') return;
    container.dataset.dsEnriched = '1';

    const handle = container.dataset.productHandle;
    const currentPlanId = String(container.dataset.currentPlanId || '');
    if (!handle || !currentPlanId) return;

    const product = await fetchProduct(handle);
    const plans = getRelevantPlans(product, currentPlanId);
    if (plans.length < 2) return; // kein Mehrwert bei nur 1 Plan

    const label = container.querySelector('.ds-cart-bundle__delivery-label');
    if (!label) return;

    const select = document.createElement('select');
    select.className = 'ds-cart-bundle__interval-select';
    select.setAttribute('data-ds-interval-select', '');
    select.setAttribute('aria-label', 'Lieferintervall wählen');
    for (const plan of plans) {
      const opt = document.createElement('option');
      opt.value = String(plan.id);
      opt.textContent = plan.name;
      if (String(plan.id) === currentPlanId) opt.selected = true;
      select.appendChild(opt);
    }
    label.replaceWith(select);
  }

  function enrichAll() {
    document.querySelectorAll('[data-ds-bundle-delivery]').forEach(enrichOne);
  }

  // Alle Abo-Items eines Bundles auf einen neuen Plan-Namen umstellen.
  // Pro Produkt wird der Plan mit passendem Namen gesucht — IDs unterscheiden
  // sich zwischen Produkten, der Name ist der stabile Schlüssel.
  //
  // Performance: Product-Fetches + Cart-Changes laufen PARALLEL. Shopify
  // serialisiert Cart-Writes intern, aber die Netzwerk-Latenzen werden
  // parallelisiert — bei 4 Items ca. 3× schneller als sequentiell.
  async function changeInterval(bundleSetId, newPlanName, selectEl) {
    const cart = window.liquidAjaxCart && window.liquidAjaxCart.cart;
    if (!cart || !Array.isArray(cart.items)) return;

    const targets = cart.items.filter(item =>
      item.properties &&
      String(item.properties._set_id) === String(bundleSetId) &&
      item.selling_plan_allocation
    );
    if (targets.length === 0) return;

    const container = selectEl.closest('[data-ds-bundle-delivery]');
    selectEl.disabled = true;
    if (container) container.classList.add('is-updating');

    try {
      const targetName = newPlanName.trim();

      // 1) Parallel alle Produkte holen und den passenden Plan pro Item matchen.
      const changes = await Promise.all(targets.map(async (item) => {
        const product = await fetchProduct(item.handle);
        if (!product || !product.selling_plan_groups) return null;
        for (const g of product.selling_plan_groups) {
          const match = (g.selling_plans || []).find(p => (p.name || '').trim() === targetName);
          if (match) return { id: item.key, selling_plan: match.id, handle: item.handle };
        }
        console.warn(LOG, 'Kein Plan mit Name "' + targetName + '" für', item.handle);
        return null;
      }));

      const valid = changes.filter(Boolean);
      if (valid.length === 0) return;

      // 2) Parallel alle Cart-Changes senden. Shopify queued die intern, aber
      //    die HTTP-Roundtrips laufen gleichzeitig → deutlich weniger Gesamtzeit.
      const results = await Promise.all(valid.map(ch =>
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: ch.id, selling_plan: ch.selling_plan })
        }).then(r => ({ ok: r.ok, status: r.status, handle: ch.handle }))
          .catch(e => ({ ok: false, error: e, handle: ch.handle }))
      ));

      const failures = results.filter(r => !r.ok);
      if (failures.length > 0) {
        console.warn(LOG, 'change.js failures:', failures);
      }

      // 3) Einmal refreshen — Drawer-Sections + interner LAC-State.
      if (window.liquidAjaxCart && typeof window.liquidAjaxCart.get === 'function') {
        window.liquidAjaxCart.get();
      }
    } catch (e) {
      console.error(LOG, 'changeInterval error', e);
    } finally {
      selectEl.disabled = false;
      if (container) container.classList.remove('is-updating');
    }
  }

  // Globales Change-Event: delegiert, überlebt Section-Re-Renders.
  document.addEventListener('change', function (e) {
    const select = e.target.closest('[data-ds-interval-select]');
    if (!select) return;
    const container = select.closest('[data-ds-bundle-delivery]');
    if (!container) return;
    const bundleSetId = container.dataset.bundleSetId;
    const newName = select.options[select.selectedIndex].textContent.trim();
    console.log(LOG, 'change →', newName, 'for bundle', bundleSetId);
    changeInterval(bundleSetId, newName, select);
  });

  // Enrich beim initialen Load + nach jedem Cart-Update + beim Drawer-Open.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enrichAll);
  } else {
    enrichAll();
  }
  document.addEventListener('liquid-ajax-cart:queue-end', enrichAll);
  document.addEventListener('ds-cart-drawer:opened', enrichAll);
})();


// ============================================================================
// KONSTANTEN & INITIALISIERUNG
// ============================================================================

/**
 * Schlüssel für den Local Storage, unter dem die aktive Kampagne gespeichert wird
 * @constant {string}
 */
const STORAGE_KEY = 'active_campaign';

/**
 * Kampagnen-Daten aus dem JSON-Element im DOM lesen
 * Die Daten werden aus dem Element mit der ID 'ds-cart-campaigns' gelesen
 * und sind base64-kodiert
 */
const campaignsJson = JSON.parse(document.getElementById('ds-cart-campaigns').textContent);

/**
 * UTF-8 aware Base64 decode
 * atob() allein unterstützt keine UTF-8 Multi-Byte-Zeichen (Umlaute etc.)
 */
function decodeBase64Utf8(base64) {
  const binaryString = atob(base64);
  const bytes = Uint8Array.from(binaryString, char => char.charCodeAt(0));
  return new TextDecoder('utf-8').decode(bytes);
}

const existingCampaigns = JSON.parse(decodeBase64Utf8(campaignsJson.campaigns));


// ============================================================================
// HILFSFUNKTIONEN - KAMPAGNEN VERWALTUNG
// ============================================================================

/**
 * Bestimmt die aktuell aktive Kampagne basierend auf dem Warenkorb-Status
 * 
 * Priorität:
 * 1. Kampagne, deren Code im cart.attributes.active_code gesetzt ist
 * 2. Kampagne mit anwendbarem Discount-Code (applicable === true)
 * 3. Kampagne, deren Code im Warenkorb liegt (auch wenn nicht applicable)
 * 4. Standard-Kampagne (is_standard_campaign === true)
 *
 * WICHTIG: Versand-Codes (z.B. BACKVERLIEBT) sind im Warenkorb nie "applicable",
 * da Shopify Versandrabatte erst im Checkout anwendet – daher Punkt 3.
 *
 * @returns {Object|null} Die aktive Kampagne oder null bei Fehler
 */
function determineActiveCampaign() {
  const cart = window.liquidAjaxCart.cart;

  try {
    // Standard-Kampagne suchen (Fallback)
    const standardCampaign = existingCampaigns.find(camp => camp.is_standard_campaign === true);

    // Alle Codes im Warenkorb, unabhängig von "applicable" (Vergleich case-insensitive).
    // Beim Page Load kommt der Cart aus {{ cart | json }} – dort gibt es kein discount_codes,
    // dann dem active_code Attribut vertrauen (sonst springt die Kampagne nach Reload zurück)
    const discountCodes = Array.isArray(cart.discount_codes)
      ? cart.discount_codes.map(dc => dc.code)
      : [cart.attributes?.active_code];
    const cartCodes = [
      ...discountCodes,
      ...(cart.cart_level_discount_applications || []).map(da => da.title)
    ].filter(Boolean).map(code => code.toLowerCase());

    if (cartCodes.length === 0) return standardCampaign;

    const findByCode = code => code && existingCampaigns.find(camp => camp.code?.toLowerCase() === code);
    const activeCodeAttr = (cart.attributes?.active_code || '').toLowerCase();
    const applicableCode = (cart.discount_codes || []).find(dc => dc.applicable === true)?.code?.toLowerCase();

    // Priorität: active_code Attribut > applicable Code > beliebiger Code im Warenkorb > Standard-Kampagne
    const activeCampaign = (cartCodes.includes(activeCodeAttr) && findByCode(activeCodeAttr))
      || findByCode(applicableCode)
      || cartCodes.map(findByCode).find(Boolean)
      || standardCampaign;

    return activeCampaign;
  } catch (error) {
    console.error('Fehler beim Bestimmen der aktiven Kampagne:', error);
    return null;
  }
}

/**
 * Speichert die aktive Kampagne im Local Storage
 *
 * @param {Object} activeCampaign - Die zu speichernde Kampagne
 * @param {string} activeCampaign.title - Titel der Kampagne
 * @param {string} activeCampaign.code - Discount-Code der Kampagne
 * @param {boolean} activeCampaign.is_standard - Ob es die Standard-Kampagne ist
 * @param {Array} activeCampaign.steps - Kampagnen-Schritte mit Geschenken
 * @param {Array} activeCampaign.shipping_tariffs - Versandtarife der Kampagne
 * @param {string} requestCountry - ISO-Code des Landes (z.B. "DE", "AT")
 */
function setStorageCampaign(activeCampaign, requestCountry) {
  // Kampagnen-Daten mit Zeitstempel im Local Storage speichern
  localStorage.setItem(STORAGE_KEY, JSON.stringify({
    title: activeCampaign.title,
    code: activeCampaign.code,
    is_standard: activeCampaign.is_standard,
    steps: activeCampaign.steps,
    shipping_tariffs: activeCampaign.shipping_tariffs,
    request_country: requestCountry,
    updated_at: new Date().toISOString()
  }));

  // Custom Event dispatchen für same-tab Updates (storage event nur cross-tab)
  document.dispatchEvent(new CustomEvent('ds-campaign-updated'));
}

/**
 * Ruft die aktive Kampagne aus dem Local Storage ab
 * 
 * @returns {Object|null} Die gespeicherte Kampagne oder null, falls keine vorhanden
 */
function getActiveCampaign() {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored ? JSON.parse(stored) : null;
}

/**
 * Berechnet und speichert den Versandstatus basierend auf Warenkorb-Wert und Versandtarifen
 * 
 * @param {number} cartTotal - Aktueller Warenkorb-Wert
 * @param {string} requestCountry - ISO-Code des Landes
 * @param {Array} shippingTariffs - Array mit Versandtarifen
 */
function setShippingStatus(cartTotal, requestCountry, shippingTariffs) {
  if (!shippingTariffs || shippingTariffs.length === 0) {
    localStorage.removeItem('ds_shipping_status');
    return;
  }

  // Passenden Tarif für das Land finden
  const tariff = shippingTariffs.find(t => t.country_code === requestCountry);
  
  if (!tariff) {
    localStorage.removeItem('ds_shipping_status');
    return;
  }

  // Versandstatus berechnen
  const isFreeShipping = cartTotal >= tariff.free_from;
  const shippingCost = isFreeShipping ? 0 : tariff.standard_cost;
  const remainingForFree = Math.max(0, tariff.free_from - cartTotal);

  // Status im Local Storage speichern
  localStorage.setItem('ds_shipping_status', JSON.stringify({
    country_code: requestCountry,
    is_free: isFreeShipping,
    cost: shippingCost,
    free_from: tariff.free_from,
    remaining: remainingForFree,
    cart_total: cartTotal,
    updated_at: new Date().toISOString()
  }));

  // Custom Event dispatchen für same-tab Updates (storage event nur cross-tab)
  document.dispatchEvent(new CustomEvent('ds-shipping-status-updated'));
}


// ============================================================================
// GESCHENK-DISMISS-VERWALTUNG
// ============================================================================
// Wenn ein Kunde ein Gratis-Geschenk manuell über den Trash-Button entfernt,
// darf "freeItemsMutation" es nicht sofort wieder hinzufügen, nur weil der
// Warenkorbwert (der sich durch das Entfernen eines kostenlosen Artikels nicht
// ändert) den Schritt weiterhin als "berechtigt" ausweist. Die Entfernung wird
// hier für die aktuelle Session vermerkt und beim erneuten Prüfen respektiert.
// Sobald der Schritt nicht mehr berechtigt ist (Warenkorbwert sinkt unter die
// Schwelle), wird der Vermerk gelöscht, damit das Geschenk bei einer neuen
// Qualifikation wieder normal angeboten werden kann.

const DISMISSED_GIFTS_KEY = 'ds_dismissed_gifts';

/**
 * Liest die Liste bereits abgelehnter Geschenke (Session-Storage)
 *
 * @returns {string[]} Array von "{stepId}:{variantId}"-Einträgen
 */
function getDismissedGifts() {
  try {
    return JSON.parse(sessionStorage.getItem(DISMISSED_GIFTS_KEY)) || [];
  } catch (error) {
    return [];
  }
}

/**
 * Prüft, ob ein Geschenk für einen Kampagnen-Schritt vom Kunden bereits abgelehnt wurde
 *
 * @param {string} stepId - ID des Kampagnen-Schritts
 * @param {number} variantId - Varianten-ID des Geschenks
 * @returns {boolean}
 */
function isGiftDismissed(stepId, variantId) {
  return getDismissedGifts().includes(`${stepId}:${variantId}`);
}

/**
 * Merkt sich, dass der Kunde ein Geschenk manuell entfernt hat
 *
 * @param {string} stepId - ID des Kampagnen-Schritts
 * @param {number} variantId - Varianten-ID des Geschenks
 */
function dismissGift(stepId, variantId) {
  const dismissed = getDismissedGifts();
  const entry = `${stepId}:${variantId}`;
  if (!dismissed.includes(entry)) {
    dismissed.push(entry);
    sessionStorage.setItem(DISMISSED_GIFTS_KEY, JSON.stringify(dismissed));
  }
}

/**
 * Löscht alle Ablehnungs-Vermerke für einen Kampagnen-Schritt
 * Wird aufgerufen, wenn der Schritt nicht mehr berechtigt ist, damit das
 * Geschenk bei einer zukünftigen Qualifikation wieder angeboten wird
 *
 * @param {string} stepId - ID des Kampagnen-Schritts
 */
function clearDismissedGiftsForStep(stepId) {
  const dismissed = getDismissedGifts().filter(entry => !entry.startsWith(`${stepId}:`));
  sessionStorage.setItem(DISMISSED_GIFTS_KEY, JSON.stringify(dismissed));
}

/**
 * Löscht den Ablehnungs-Vermerk für ein einzelnes Geschenk
 * Wird aufgerufen, wenn der Kunde ein zuvor entferntes Geschenk über
 * "ds-gift-recovery" wieder manuell hinzufügt (siehe Event "ds-gift-restored")
 *
 * @param {string} stepId - ID des Kampagnen-Schritts
 * @param {number} variantId - Varianten-ID des Geschenks
 */
function removeDismissedGift(stepId, variantId) {
  const entry = `${stepId}:${variantId}`;
  const dismissed = getDismissedGifts().filter(item => item !== entry);
  sessionStorage.setItem(DISMISSED_GIFTS_KEY, JSON.stringify(dismissed));
}


// ============================================================================
// MUTATION FUNKTIONEN - WARENKORB AKTUALISIERUNG
// ============================================================================

/**
 * Mutation: Lädt und speichert die aktive Kampagne
 * 
 * Diese Mutation wird bei jeder Warenkorb-Änderung ausgeführt und stellt sicher,
 * dass immer die korrekte Kampagne im Local Storage gespeichert ist.
 * 
 * @returns {void}
 */
function campaignLoaderMutation() {
  // Aktive Kampagne bestimmen
  const activeCampaign = determineActiveCampaign();

  // Kampagne im Local Storage speichern, falls vorhanden
  if (activeCampaign) {
    // Request Country aus dem JSON-Element lesen
    const requestCountry = campaignsJson.request_country;

    // Cart Total aus dem aktuellen Warenkorb lesen (nicht aus statischem JSON)
    const cartTotal = window.liquidAjaxCart.cart.total_price / 100;

    // Kampagne mit Request Country speichern
    setStorageCampaign(activeCampaign, requestCountry);

    // Versandstatus berechnen und speichern
    setShippingStatus(cartTotal, requestCountry, activeCampaign.shipping_tariffs);
  }
}

/**
 * Mutation: Verwaltet automatische Geschenke im Warenkorb
 * 
 * Diese Mutation:
 * 1. Prüft, welche Kampagnen-Schritte basierend auf dem Warenkorbwert erreicht wurden
 * 2. Entfernt Geschenke, die nicht mehr berechtigt sind
 * 3. Fügt neue berechtigte Geschenke hinzu
 * 4. Aktualisiert die Menge vorhandener Geschenke
 * 
 * @returns {Object|undefined} Objekt mit requests-Array für Warenkorb-Änderungen,
 *                             oder undefined, falls keine Änderungen nötig sind
 */
function freeItemsMutation() {
  // Aktive Kampagne aus Local Storage abrufen
  const activeCampaign = getActiveCampaign();
  if (!activeCampaign) return;

  // Warenkorb-Daten abrufen
  const cart = window.liquidAjaxCart.cart;
  if (!cart) return;

  // Warenkorbwert in Hauptwährungseinheit umrechnen (Cent -> Euro).
  // Geschenk-Line-Items zählen NICHT zum Wert — sonst hält der (normale)
  // Geschenkpreis den Schwellenwert künstlich über free_from_amount, z.B. wenn
  // der Rabattcode entfernt wird und das Geschenk nicht mehr gratis ist.
  const giftLinesTotal = cart.items.reduce((sum, item) =>
    (item.properties && item.properties._custom_gift_step) ? sum + item.final_line_price : sum
  , 0);
  const cartTotal = (cart.total_price - giftLinesTotal) / 100;

  // Array für alle Warenkorb-Änderungsanfragen
  const requests = [];

  // -------------------------------------------------------------------------
  // SCHRITT 1: Berechtigte Kampagnen-Schritte ermitteln
  // -------------------------------------------------------------------------

  /**
   * Filtert alle Schritte, die:
   * - Vom Typ 'automatic_gift' oder 'selectable_gifts' sind
   * - Deren Mindestbetrag (free_from_amount) erreicht wurde
   */
  const eligibleSteps = activeCampaign.steps.filter(step => {
    return (step.type === 'automatic_gift' || step.type === 'selectable_gifts')
      && cartTotal >= step.free_from_amount;
  });

  // -------------------------------------------------------------------------
  // SCHRITT 2: Alle gültigen Geschenk-Varianten-IDs sammeln
  // -------------------------------------------------------------------------

  /**
   * Sammelt alle Varianten-IDs von Geschenken aus berechtigten Schritten
   * Diese Liste wird verwendet, um nicht mehr berechtigte Geschenke zu entfernen
   */
  let validGiftVariantIds = [];
  eligibleSteps.forEach(step => {
    if (step.gift_products) {
      step.gift_products.forEach(product => {
        if (product.variant_id) {
          validGiftVariantIds.push(product.variant_id);
        }
      });
    }
  });

  // -------------------------------------------------------------------------
  // SCHRITT 3: Nicht mehr berechtigte Geschenke entfernen & Mengen anpassen
  // -------------------------------------------------------------------------

  /**
   * Objekt für /cart/update.js Request
   * Format: { [line_item_key]: quantity }
   */
  const updates = {};

  /**
   * Gültige Step-IDs = nur Schritte, deren Schwellenwert aktuell erreicht ist.
   * Nicht eligible = Betrag unterschritten ODER Kampagne gewechselt → Geschenk entfernen.
   */
  const eligibleStepIds = eligibleSteps.map(step => String(step.id));

  /**
   * Für Schritte, die nicht mehr berechtigt sind, den Ablehnungs-Vermerk löschen.
   * So wird ein zuvor abgelehntes Geschenk bei einer neuen Qualifikation
   * (Warenkorbwert fällt unter die Schwelle und steigt später wieder darüber)
   * erneut normal angeboten, statt dauerhaft blockiert zu bleiben.
   */
  activeCampaign.steps.forEach(step => {
    const stepIsGiftStep = step.type === 'automatic_gift' || step.type === 'selectable_gifts';
    if (stepIsGiftStep && !eligibleStepIds.includes(String(step.id))) {
      clearDismissedGiftsForStep(String(step.id));
    }
  });

  cart.items.forEach(item => {
    if (item.properties && item.properties._custom_gift_step) {
      const itemStepId = String(item.properties._custom_gift_step);

      if (!eligibleStepIds.includes(itemStepId)) {
        updates[item.key] = 0;
      }
    }
  });

  /**
   * Für jeden berechtigten Schritt: Custom Gifts validieren
   */
  eligibleSteps.forEach(step => {
    const stepId = String(step.id);
    const giftSelectionLimit = step.gift_selection_limit || 1;

    // Finde alle Custom Gifts für diesen Schritt
    const customGiftsForStep = cart.items.filter(item =>
      item.properties &&
      item.properties._custom_gift_step === stepId
    );

    // Wenn mehr Custom Gifts als erlaubt: Überschüssige auf 0 setzen
    if (customGiftsForStep.length > giftSelectionLimit) {
      for (let i = 0; i < customGiftsForStep.length; i++) {
        // Erste N Gifts behalten (quantity = 1), Rest entfernen (quantity = 0)
        updates[customGiftsForStep[i].key] = (i < giftSelectionLimit ? 1 : 0);
      }
    }
  });

  // Veraltetes active_code Attribut leeren, wenn kein Code mehr im Warenkorb liegt
  // (der Cart-Drawer bestimmt darüber die Versandkosten-Kampagne).
  // Nur wenn discount_codes bekannt ist – im Page-Load-State ({{ cart | json }}) fehlt es.
  const attributes = {};
  if (Array.isArray(cart.discount_codes) && cart.discount_codes.length === 0 && cart.attributes?.active_code) {
    attributes.active_code = '';
  }

  // Update-Request erstellen, falls Artikel-Entfernungen oder Attribut-Änderungen vorliegen
  if (Object.keys(updates).length > 0 || Object.keys(attributes).length > 0) {
    const updateBody = { updates };
    if (Object.keys(attributes).length > 0) {
      updateBody.attributes = attributes;
    }

    requests.push({
      type: 'update',
      body: updateBody
    });
  }

  // -------------------------------------------------------------------------
  // SCHRITT 4: Neue automatische Geschenke hinzufügen
  // -------------------------------------------------------------------------

  /**
   * Array für neue Artikel, die dem Warenkorb hinzugefügt werden sollen
   * Wird am Ende als ein einziger 'add'-Request gesendet
   */
  const itemsToAdd = [];

  eligibleSteps.forEach(step => {
    // Nur automatische Geschenke verarbeiten (selectable_gifts werden separat behandelt)
    if (step.type === 'automatic_gift' && step.gift_products) {
      step.gift_products.forEach(gift => {
        const variantId = gift.variant_id;
        const stepId = step.id;

        const stepAmount = gift.amount || 1; // Standardmenge ist 1

        // Prüfen, ob Artikel bereits im Warenkorb vorhanden ist
        const existingItem = cart.items.find(item =>
          item.variant_id === variantId
          // && item.line_price <= 0  // Optional: Nur kostenlose Artikel berücksichtigen
        );

        if (existingItem) {
          // ---------------------------------------------------------------
          // Artikel existiert bereits: Menge aktualisieren falls nötig
          // ---------------------------------------------------------------

          // Nur Linien mit _custom_gift_step wurden von dieser Logik angelegt.
          // Regulär gekaufte Linien derselben Variante (ohne Property)
          // dürfen nie reduziert werden.
          const isManagedGift = existingItem.properties
            && existingItem.properties._custom_gift_step;

          // Menge exakt auf die Schritt-Menge klemmen: erhöht zu niedrige
          // Mengen und heilt manipulierte Geschenk-Linien (z. B. Stepper auf
          // /cart, parallele Tabs, direkte /cart/change.js-Aufrufe) zurück.
          if (existingItem.quantity < stepAmount
            || (isManagedGift && existingItem.quantity > stepAmount)) {
            requests.push({
              type: 'change',
              body: {
                id: existingItem.key,  // Wichtig: key verwenden, nicht variant_id
                quantity: stepAmount
              }
            });
          }
        } else {
          // ---------------------------------------------------------------
          // Artikel existiert nicht: Zum Hinzufügen vormerken
          // Außer der Kunde hat dieses Geschenk in dieser Session bereits
          // manuell über den Trash-Button entfernt (siehe dismissGift())
          // ---------------------------------------------------------------

          if (isGiftDismissed(String(stepId), variantId)) return;

          itemsToAdd.push({
            id: variantId,
            quantity: stepAmount,
            properties: {
              _custom_gift_step: String(stepId)     // Zuordnung zum Kampagnen-Schritt
            }
          });
        }
      });
    }
  });

  // Alle neuen Artikel in einem Request hinzufügen (effizienter als einzelne Requests)
  if (itemsToAdd.length > 0) {
    requests.push({
      type: 'add',
      body: {
        items: itemsToAdd
      }
    });
  }

  // -------------------------------------------------------------------------
  // RÜCKGABE: Requests an Liquid Ajax Cart zurückgeben
  // -------------------------------------------------------------------------

  /**
   * Wenn Änderungen vorliegen, werden diese als requests-Array zurückgegeben
   * Liquid Ajax Cart führt diese dann aus
   */
  if (requests.length > 0) {
    return {
      requests: requests
    };
  }
}


// ============================================================================
// BUNDLE MIGRATION - PRODUKTE INS BUNDLE INTEGRIEREN
// ============================================================================

/**
 * Mutation: Migriert Einzelprodukte automatisch ins bestehende Bundle
 *
 * Wenn ein Kunde ein Produkt von einer normalen PDP hinzufügt und bereits ein Bundle
 * im Warenkorb existiert, wird das Produkt automatisch dem Bundle zugeordnet.
 *
 * @returns {Object|undefined} Objekt mit requests-Array für Warenkorb-Änderungen
 */
function bundleMigrationMutation() {
  const cart = window.liquidAjaxCart.cart;
  if (!cart || !cart.items || cart.items.length === 0) return;

  // -------------------------------------------------------------------------
  // SCHRITT 1: Bundle im Warenkorb finden
  // -------------------------------------------------------------------------

  // Finde alle Items mit _set_id (Bundle-Items)
  const bundleItems = cart.items.filter(item =>
    item.properties && item.properties._set_id
  );

  // Wenn kein Bundle vorhanden: nichts zu tun
  if (bundleItems.length === 0) return;

  // Bundle-Informationen vom ersten Bundle-Item extrahieren
  const firstBundleItem = bundleItems[0];
  const bundleSetId = firstBundleItem.properties._set_id;
  const bundlePaket = firstBundleItem.properties._paket || '';
  const bundleSetImage = firstBundleItem.properties._set_image || '';
  const bundleSellingPlan = firstBundleItem.properties._selling_plan || '';
  const bundleUrl = firstBundleItem.properties._url || '';

  // Prüfe ob das Bundle ein Abo ist (hat selling_plan_allocation)
  const bundleHasSubscription = firstBundleItem.selling_plan_allocation != null;

  // -------------------------------------------------------------------------
  // SCHRITT 2: Einzelprodukte ohne Bundle-Zuordnung finden
  // -------------------------------------------------------------------------

  // Finde Items OHNE _set_id (keine Gift-Items berücksichtigen)
  const orphanItems = cart.items.filter(item => {
    // Keine Properties = Einzelprodukt
    if (!item.properties) return true;

    // Hat _set_id = gehört bereits zu Bundle
    if (item.properties._set_id) return false;

    // Hat _custom_gift_step = ist ein Geschenk, nicht migrieren
    if (item.properties._custom_gift_step) return false;

    // Alle anderen Items ohne _set_id sind Einzelprodukte
    return true;
  });

  console.group('[DS Bundle Migration]');
  console.log('Bundle Items:', bundleItems.map(i => i.title + ' (_set_id: ' + i.properties._set_id + ')'));
  console.log('Orphan Items (werden migriert):', orphanItems.map(i => i.title));
  console.groupEnd();

  // Wenn keine Einzelprodukte vorhanden: nichts zu tun
  if (orphanItems.length === 0) return;

  // -------------------------------------------------------------------------
  // SCHRITT 3: Einzelprodukte ins Bundle migrieren
  // -------------------------------------------------------------------------

  const requests = [];
  const itemsToRemove = {};
  const itemsToAdd = [];

  orphanItems.forEach(item => {
    // Prüfe ob das gleiche Produkt bereits im Bundle existiert
    const existingBundleItem = bundleItems.find(bundleItem =>
      bundleItem.variant_id === item.variant_id
    );

    if (existingBundleItem) {
      // Produkt existiert bereits im Bundle: Menge erhöhen
      // Altes Item entfernen
      itemsToRemove[item.key] = 0;

      // Bestehende Bundle-Menge erhöhen
      requests.push({
        type: 'change',
        body: {
          id: existingBundleItem.key,
          quantity: existingBundleItem.quantity + item.quantity
        }
      });
    } else {
      // Produkt ist neu: Zum Bundle hinzufügen
      // Altes Item ohne Bundle-Properties entfernen
      itemsToRemove[item.key] = 0;

      // Neues Item mit Bundle-Properties hinzufügen
      const newItem = {
        id: item.variant_id,
        quantity: item.quantity,
        properties: {
          '_set_id': bundleSetId,
          '_set_image': bundleSetImage,
          '_selling_plan': bundleSellingPlan,
          '_paket': bundlePaket,
          '_url': bundleUrl
        }
      };

      // Wenn das Bundle ein Abo hat, Selling Plan übernehmen
      if (bundleHasSubscription && firstBundleItem.selling_plan_allocation) {
        newItem.selling_plan = firstBundleItem.selling_plan_allocation.selling_plan.id;
      }

      itemsToAdd.push(newItem);
    }
  });

  // -------------------------------------------------------------------------
  // SCHRITT 4: Requests zusammenstellen
  // -------------------------------------------------------------------------

  // Zuerst alte Items entfernen
  if (Object.keys(itemsToRemove).length > 0) {
    requests.unshift({
      type: 'update',
      body: {
        updates: itemsToRemove
      }
    });
  }

  // Dann neue Items mit Bundle-Properties hinzufügen
  if (itemsToAdd.length > 0) {
    requests.push({
      type: 'add',
      body: {
        items: itemsToAdd
      }
    });
  }

  if (requests.length > 0) {
    return { requests };
  }
}


// ============================================================================
// EBENE 2 — EXCLUSIVITY GUARD (Safety Net)
// ============================================================================

/**
 * Erkennt gemischte Carts (Abo + Einmalkauf gleichzeitig) nach jeder
 * Cart-Mutation. Feuert ein Event, entfernt selbst nichts — Pre-Check
 * auf UI-Ebene ist der Hauptmechanismus, das hier ist nur Signalisierung.
 * Nützlich, falls ein Drittanbieter-Widget oder ein direkter /cart/add.js
 * den Pre-Check umgeht.
 */
function exclusivityGuardMutation() {
  const cart = window.liquidAjaxCart.cart;
  if (!cart || !Array.isArray(cart.items)) return;
  const getItemMode = window.dsCartExclusivity && window.dsCartExclusivity.getItemMode;
  if (typeof getItemMode !== 'function') return;

  let hasAbo = false;
  let hasEinmal = false;
  for (const item of cart.items) {
    const mode = getItemMode(item);
    if (mode === 'abo') hasAbo = true;
    else if (mode === 'einmal') hasEinmal = true;
    if (hasAbo && hasEinmal) break;
  }

  if (hasAbo && hasEinmal) {
    console.warn('[DS Cart Guard] Mixed cart detected — subscription and one-time bundle coexist.');
    try {
      document.dispatchEvent(new CustomEvent('ds-cart:conflict-detected', {
        detail: { hasAbo, hasEinmal }
      }));
    } catch (_) {}
  }
}


// ============================================================================
// LIQUID AJAX CART KONFIGURATION
// ============================================================================

/**
 * Registriert die Mutation-Funktionen bei Liquid Ajax Cart
 * Diese werden bei jeder Warenkorb-Änderung in der angegebenen Reihenfolge ausgeführt
 */
window.liquidAjaxCart.conf('mutations', [
  campaignLoaderMutation,    // Zuerst: Kampagne laden und speichern
  exclusivityGuardMutation,  // Safety-Net: Mixed-Cart erkennen (Abo + Einmal)
  bundleMigrationMutation,   // Dann: Einzelprodukte ins Bundle migrieren
  freeItemsMutation          // Zuletzt: Geschenke verwalten
]);

/**
 * Deaktiviert automatische Warenkorb-Updates beim Fokussieren des Fensters
 * Verhindert unnötige Server-Anfragen
 */
window.liquidAjaxCart.conf("updateOnWindowFocus", false);

/**
 * Discount-Link (/discount/CODE) setzt nur das Shopify-Cookie "discount_code" –
 * Code und active_code landen nicht im Warenkorb, die Kampagne (Versandkosten)
 * bliebe auf Standard. Daher Code einmalig in den Warenkorb übernehmen,
 * genau wie beim manuellen Einlösen in ds-cart-discount.js.
 * Cookie danach löschen, sonst würde ein später entfernter Code beim nächsten
 * Seitenaufruf erneut eingelöst.
 */
function syncDiscountLinkCode() {
  const match = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
  if (!match) return;

  const code = decodeURIComponent(match[1]).trim();
  document.cookie = 'discount_code=; path=/; max-age=0';
  document.cookie = `discount_code=; path=/; max-age=0; domain=.${location.hostname.replace(/^www\./, '')}`;

  if (!code || code.toLowerCase() === (window.liquidAjaxCart.cart?.attributes?.active_code || '').toLowerCase()) return;

  window.liquidAjaxCart.update({ discount: code, attributes: { active_code: code } });
}

if (window.liquidAjaxCart.init) {
  syncDiscountLinkCode();
} else {
  document.addEventListener('liquid-ajax-cart:init', syncDiscountLinkCode);
}

/**
 * Erkennt, wenn der Kunde ein Geschenk (Artikel mit "_custom_gift_step") manuell
 * über den Trash-Button entfernt (Request: /cart/change?...&quantity=0) und merkt
 * dies über dismissGift() vor, BEVOR "freeItemsMutation" erneut läuft.
 *
 * "request-start" feuert, bevor der Request an Shopify gesendet wird – der
 * Warenkorb-Snapshot in window.liquidAjaxCart.cart entspricht daher noch dem
 * Stand vor der Entfernung und enthält das Geschenk (inkl. "_custom_gift_step").
 */
document.addEventListener('liquid-ajax-cart:request-start', (event) => {
  const { requestState } = event.detail;
  if (requestState.requestType !== 'change') return;

  const body = requestState.requestBody;
  let itemKey;
  let quantity;

  if (body instanceof FormData || body instanceof URLSearchParams) {
    itemKey = body.get('id');
    quantity = body.get('quantity');
  } else if (body) {
    itemKey = body.id;
    quantity = body.quantity;
  }

  // Nur eine vollständige Entfernung (quantity 0) zählt als "abgelehnt"
  if (!itemKey || Number(quantity) !== 0) return;

  const cart = window.liquidAjaxCart.cart;
  const item = cart?.items.find(cartItem => String(cartItem.key) === String(itemKey));
  const stepId = item?.properties?._custom_gift_step;

  if (stepId) {
    dismissGift(String(stepId), item.variant_id);
  }
});

/**
 * Wird von "ds-gift-recovery" gefeuert, sobald der Kunde ein zuvor entferntes
 * Geschenk manuell wieder hinzugefügt hat. Löscht den Ablehnungs-Vermerk, damit
 * der Zustand konsistent bleibt (Geschenk ist wieder im Warenkorb → nicht mehr
 * "abgelehnt").
 */
document.addEventListener('ds-gift-restored', (event) => {
  const { stepId, variantId } = event.detail || {};
  if (stepId && variantId) {
    removeDismissedGift(String(stepId), variantId);
  }
});